import { render, staticRenderFns } from "./buy-request-store-order.vue?vue&type=template&id=545a9b4a&scoped=true"
import script from "./buy-request-store-order.vue?vue&type=script&lang=js"
export * from "./buy-request-store-order.vue?vue&type=script&lang=js"
import style0 from "./buy-request-store-order.vue?vue&type=style&index=0&id=545a9b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a9b4a",
  null
  
)

export default component.exports